export const slugify = (text: string) =>
  text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+|(^-|-$)/g, "-")
    .replace(/(^-+|-+$)/g, "");

export const stripTrailingSlash = (url: string) => url.replace(/\/+$/, "");

export const stripLeadingSlash = (url: string) => url.replace(/^\/+/, "");
